import clsx from 'clsx';
import Link from 'next/link';
import { FC } from 'react';
import React from 'react';
import styles from './TabsList.module.scss';
import { TabsListProps } from './TabsList.type';

export const TabsList: FC<TabsListProps> = ({ tabs, activeTab }) => (
    <div className={styles.tabs}>
        {tabs.map((tab) => (
            <Link key={tab.name} href={tab.href}>
                <a
                    className={clsx(
                        styles.tabItem,
                        activeTab === tab.name && styles.active
                    )}
                >
                    {tab.title}
                </a>
            </Link>
        ))}
    </div>
);
